var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14279 4.85707C7.14279 2.33234 9.18949 0.285645 11.7142 0.285645H16.2856C18.8104 0.285645 20.8571 2.33234 20.8571 4.85707H26.5714C27.2025 4.85707 27.7142 5.36875 27.7142 5.99993C27.7142 6.63111 27.2025 7.14279 26.5714 7.14279H25.3728L24.67 21.1995C24.4875 24.8489 21.4754 27.7142 17.8214 27.7142H10.1785C6.5245 27.7142 3.51238 24.8489 3.32991 21.1995L2.62707 7.14279H1.4285C0.797319 7.14279 0.285645 6.63111 0.285645 5.99993C0.285645 5.36875 0.797319 4.85707 1.4285 4.85707H7.14279ZM4.91564 7.14279L5.61277 21.0854C5.73442 23.5183 7.7425 25.4285 10.1785 25.4285H17.8214C20.2574 25.4285 22.2654 23.5183 22.3871 21.0854L23.0842 7.14279H4.91564ZM18.5714 4.85707H9.4285C9.4285 3.59471 10.4519 2.57136 11.7142 2.57136H16.2856C17.548 2.57136 18.5714 3.59471 18.5714 4.85707ZM10.5714 11.7142C11.2025 11.7142 11.7142 12.2259 11.7142 12.8571V18.5714C11.7142 19.2025 11.2025 19.7142 10.5714 19.7142C9.94018 19.7142 9.4285 19.2025 9.4285 18.5714V12.8571C9.4285 12.2259 9.94018 11.7142 10.5714 11.7142ZM17.4285 11.7142C18.0597 11.7142 18.5714 12.2259 18.5714 12.8571V18.5714C18.5714 19.2025 18.0597 19.7142 17.4285 19.7142C16.7973 19.7142 16.2856 19.2025 16.2856 18.5714V12.8571C16.2856 12.2259 16.7973 11.7142 17.4285 11.7142Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGreenIcon);
export default __webpack_public_path__ + "static/media/delete-green-icon.7d5ecd1cb67f17d9fc6c1cc1668b1ef1.svg";
export { ForwardRef as ReactComponent };